/**
 * useEscapeKey - Universal Escape Key Handler
 * 
 * Standard hook for closing modals/dialogs with Escape key
 * Part of Interfacr/Commandr standard keyboard shortcuts
 * 
 * CHANGE HISTORY:
 * - 251108_0010 [pending] danielbeer: Created universal Esc key handler
 */

import { useEffect } from 'react';

export function useEscapeKey(onEscape: () => void, enabled: boolean = true) {
  useEffect(() => {
    if (!enabled) return;

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
        onEscape();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [onEscape, enabled]);
}
